import { findIconDefinition } from "@fortawesome/fontawesome-svg-core";

const ValidateFaIconHook = {
  mounted() {
    window.addEventListener("validate-fa-icon", (event) => {
      const icon = findIconDefinition({ iconName: event.target.value });
      if (icon) {
        this.pushEventTo("#admin-tag-form", "validate-fa-icon-result", {
          valid: true,
        });
      } else {
        this.pushEventTo("#admin-tag-form", "validate-fa-icon-result", {
          valid: false,
        });
      }
    });
  },
};

export default ValidateFaIconHook;
